var _clipPath, _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 120 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v15h70v15H60zm0 30v10h30V0h30z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h120v60H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#c8102e",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0l60 30m0-30L0 30",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0l60 30m0-30L0 30",
    clipPath: "url(#a)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 0v40M0 15h70",
    stroke: "#fff",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 0v40M0 15h70"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 0h60v60H0V30h60z",
    fill: "#fedd00"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30 15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.1039)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1,
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M0-513674l301930 929245-790463-574305h977066l-790463 574305",
    fill: "#fedd00",
    transform: "scale(0.00000194676)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "matrix(3 0 0 3 -17.5 .29)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "matrix(3 0 0 3 17.5 .29)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "matrix(3 0 0 3 0 10.29)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "matrix(3 0 0 3 0 -9.71)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNu);
export default __webpack_public_path__ + "static/media/nu.8c86d48ee514a35578e4c980b75c0037.svg";
export { ForwardRef as ReactComponent };